import builder from '../builder';
import SocialMediaFacebook1 from '../../streamline-icons/light/social-media-facebook-1.svg';

export default builder('IconSocialMediaFacebook1Light', SocialMediaFacebook1);
